import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'access_token';
const USER_TYPE_KEY = 'user_type';
const USER_ID_KEY = 'user_id';

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const saveToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getUserType = () => localStorage.getItem(USER_TYPE_KEY);

export const saveUserType = (userType) => {
  localStorage.setItem(USER_TYPE_KEY, userType || '');
};

export const removeUserType = () => {
  localStorage.removeItem(USER_TYPE_KEY);
};

export const getUserId = () => {
  const userId = localStorage.getItem(USER_ID_KEY);
  return userId ? parseInt(userId, 10) : null;
};

export const saveUserId = (userId) => {
  if (userId == null) {
    localStorage.removeItem(USER_ID_KEY);
    return;
  }
  localStorage.setItem(USER_ID_KEY, String(userId));
};

export const removeUserId = () => {
  localStorage.removeItem(USER_ID_KEY);
};

export const saveUserData = (token, userType, userId) => {
  saveToken(token);
  saveUserType(userType);
  saveUserId(userId);
};

export const clearUserData = () => {
  removeToken();
  removeUserType();
  removeUserId();
};

export function decodeAccessToken(token = getToken()) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isTokenExpired(token = getToken(), skewMs = 5_000) {
  const decoded = decodeAccessToken(token);
  if (!decoded?.exp) return true;
  return decoded.exp * 1000 <= Date.now() + skewMs;
}

export function getValidToken() {
  const token = getToken();
  if (!token) return null;
  if (isTokenExpired(token)) {
    clearUserData();
    return null;
  }
  return token;
}

export function msUntilExpiry(token = getToken()) {
  const decoded = decodeAccessToken(token);
  if (!decoded?.exp) return 0;
  return Math.max(0, decoded.exp * 1000 - Date.now());
}

export const isAuthenticated = () => !!getValidToken();

export const isAdmin = () => getUserType() === 'admin';
export const isClinician = () => getUserType() === 'clinician';
export const isPatient = () => getUserType() === 'patient';
